import { render } from "./elixir-huntflow-bubble-active.svg?vue&type=template&id=18cbd912&vue"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__